import React, {useState} from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend, ResponsiveContainer
} from "recharts";
import DOMPurify from "dompurify";

function CustomToolTip({ active, payload, label }) {
    const renderHtml = (htmlString) => {
        const sanitizedHtml = DOMPurify.sanitize(htmlString);
        return { __html: sanitizedHtml };
    };

    if (active && payload && payload.length) {

        const sum = payload.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.value;
        }, 0);

        return (
            <div className={'bg-columbia_blue-400 text-dutch_white-800 p-1 max-w-[210px] overflow text-xs opacity-90 rounded'}>
                <div dangerouslySetInnerHTML={renderHtml(label)}/>
                <br/>
                {payload.map(item => (<p>{item.dataKey}: {item.value} ({Math.round(item.value / sum * 100)}%)</p>))}
            </div>
        )
    }

    return null;
}

function CustomXTick({ active, payload, label }) {
    const renderHtml = (htmlString) => {
        const sanitizedHtml = DOMPurify.sanitize(htmlString);
        return { __html: sanitizedHtml };
    };

    if (active && payload && payload.length) {
        return (
            <div className={'bg-dutch_white-400 text-dutch_white-800 p-2 max-w-[170px] overflow text-lg'}>
                {/*<div dangerouslySetInnerHTML={renderHtml(label)}/>*/}
                <p>this matters</p>
                <br />
                {payload.map(item => (<p>{item.dataKey}: {item.value}</p>))}
            </div>
        )
    }

    return null;
}


export default function RecallBarChart({ data, handleBarClick }) {
    const [focusedBar, setFocusedBar] = useState(null);


    return (
        <div className={'w-full'}onKeyDown={(e) => {
            if (e.key === 'Enter') {
                e.preventDefault()
                e.stopPropagation()
                handleBarClick(focusedBar);
            }
        }}>
            <ResponsiveContainer width='100%' height={300}>
                <BarChart
                    data={data}
                    margin={{
                        top: 10,
                        right: 20,
                        left: 20,
                        bottom: 5
                    }}
                    onClick={handleBarClick}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleBarClick(); // Trigger the same function as onClick
                        }
                    }}
                    role="button"
                >
                    <CartesianGrid strokeDasharray="3 3" stroke="#eeeeee" />
                    <XAxis dataKey='name' className={'font-bold'} tick={CustomXTick}/>
                    {/*<YAxis stroke="#eeeeee" />*/}
                    <Tooltip cursor={false} content={<CustomToolTip />} />
                    <Legend />
                    <Bar dataKey="Correct" stackId="a" fill="#538ea5" tabIndex={0} label={{
                        dataKey: 'name',
                        position: "insideBottom",
                        angle: 0,
                        fill: "#E8DAB2",
                        offset: 25
                    }} onFocus={(e) => {
                        const { payload } = e
                        setFocusedBar(payload);}}/>
                    <Bar dataKey="Incorrect" stackId="a" fill="#dd6e42" />
                    <Bar dataKey="Pending" stackId="a" fill="#8b8b8b" />
                </BarChart>
            </ResponsiveContainer>
        </div>


    );
}
